<template>
  <div class="customize-report">
    <h1>自定义报表</h1>
    <p>报表功能开发中...</p>
  </div>
</template>

<script>
export default {
  name: 'CustomizeReport'
}
</script>

<style scoped>
.customize-report {
  padding: 20px;
}
</style>
